module.exports = __webpack_public_path__ + "img/A15_20170206-001.1bef3fe6.jpg";